/**
 * 需求来源：docs/合作页、CJ Entity、Ads开户落地页3个/AI提示词.md（第2次提交 任务1）、advertisingservice.html。
 * Section 6：cj-three-step-process 3 步流程（PC 3 列带连线，≤980 转竖排时间轴）。
 * 注意事项：文案（eyebrow/title/desc/steps）经 ConstantsContext 取词，配色与 SVG 图标为视觉资产保留在组件内。
 */
import React, { useContext } from 'react';
import ConstantsContext from './ConstantsContext';
import { mix } from '../colorMix';

// 视觉资产（配色 + 图标）顺序与 THREE_STEP.steps 一一对应
var STEP_VISUALS = [
  {
    accent: '#4f7cff', soft: 'rgba(79,124,255,.12)',
    icon: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="10" cy="8" r="3" /><path d="M4 19c0-3.3 2.7-6 6-6 1.2 0 2.3.3 3.2.9" /><circle cx="17" cy="15" r="3" /><path d="m19.2 17.2 2.3 2.3" /></svg>),
  },
  {
    accent: '#8b5cf6', soft: 'rgba(139,92,246,.12)',
    icon: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="6" width="18" height="13" rx="3" /><path d="M3 10h18" /><path d="M7 15h4" /></svg>),
  },
  {
    accent: '#ff914d', soft: 'rgba(255,145,77,.13)',
    icon: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 4c3.5.7 5.3 2.5 6 6l-5.5 5.5-6-6L14 4Z" /><path d="m8.5 9.5-3.5 1-2 2 4 1" /><path d="m14.5 15.5-1 3.5-2 2-1-4" /><circle cx="15" cy="9" r="1.5" /><path d="M5 19c1.5-1.5 3.5-2 5-1-1 1.5-2.5 3-5 3v-2Z" /></svg>),
  },
];

// 由 accent 主色预算派生 CSS 变量（等价原 less 的 color-mix）
function accentVars(accent, soft) {
  if (!accent) return { '--soft': soft };
  return {
    '--accent': accent,
    '--soft': soft,
    '--accent-hover-bd': mix(accent, '#dfe5ee', 30),     // hover 描边
    '--accent-icon-bd': mix(accent, 'transparent', 24),  // 图标描边
    '--accent-icon-bg': mix(accent, '#ffffff', 11),      // 图标浅底
    '--accent-icon-glow': mix(accent, 'transparent', 12),// 图标投影
    '--accent-num-bd': mix(accent, '#edf1f6', 20),       // 序号描边
    '--accent-num-tx': mix(accent, '#273140', 76),       // 序号文字（压暗）
    '--accent-num-bg': mix(accent, '#ffffff', 8),        // 序号浅底
  };
}

function ThreeStep() {
  const { THREE_STEP } = useContext(ConstantsContext);
  return (
    <section className="cj-three-step-process">
      <div className="cj-three-step-process__wrap">
        <div className="cj-three-step-process__head">
          <div className="cj-three-step-process__eyebrow">{THREE_STEP.eyebrow}</div>
          <h2 className="cj-three-step-process__title">
            {THREE_STEP.title}
            <span className="accent"> {THREE_STEP.titleAccent}</span>
          </h2>
          <p className="cj-three-step-process__desc">{THREE_STEP.description}</p>
        </div>

        <div className="cj-three-step-process__grid">
          {THREE_STEP.steps.map((s, i) => {
            var v = STEP_VISUALS[i] || {};
            return (
              <article className="cj-three-step-card" key={s.num} style={accentVars(v.accent, v.soft)}>
                <div className="cj-three-step-card__top">
                  <div className="cj-three-step-card__icon">{v.icon}</div>
                  <span className="cj-three-step-card__number">{s.num}</span>
                </div>
                <h3>{s.h3}</h3>
                <p>{s.p}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default ThreeStep;
